export default __webpack_public_path__ + "static/media/enquiries-icon.c13b3366.svg";